import { useState, useEffect } from "react";
import { saveRegionDetails, getAllCountries } from "../Api/RegionMaster";
import { Container, Form, Button, Row, Col } from "react-bootstrap";

import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";

const RegionMaster = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;

  const [regionData, setRegionData] = useState({
    region: "",
    countryCode: "",
    regionCode: "",
    regionName: ""
  });

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await getAllCountries();
        setCountries(response);
      } catch (error) {
        toast.error(`🦄 Error: ${error.message || "Failed to fetch countries"}`);
      }
    };
    fetchCountries();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRegionData({
      ...regionData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveRegionDetails(regionData, userId);
      toast.success(`🦄 Region Added Successfully`);
      setRegionData({
        region: "",
        countryCode: "",
        regionCode: "",
        regionName: ""
      });
      navigate("/viewRegion");
    } catch (error) {
      toast.error(`🦄 Error: ${error.message || "Failed to save region details"}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="fields-container">
            <h2 className="fields-title">Region Master</h2>

            <Form onSubmit={handleSubmit} className="fields-form">
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Region <span className="text-red">**</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="region"
                      value={regionData.region}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Country Code <span className="text-red">**</span></Form.Label>
                    <Form.Select
                      name="countryCode"
                      value={regionData.countryCode}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Country</option>
                      {countries.map((country) => (
                        <option key={country.countryCode} value={country.countryCode}>
                          {country.countryCode} - {country.countryName}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Region Code <span className="text-red">**</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="regionCode"
                      value={regionData.regionCode}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Region Name <span className="text-red">**</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="regionName"
                      value={regionData.regionName}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              <div className="fields-btn-container">
                <Button variant="primary" type="submit" className="fields-submit">
                  Save Region
                </Button>
              </div>
            </Form>
          </Container>
        </div>
      

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default RegionMaster;